// Core
import { Fragment, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Chakra
import {
  Box,
  Button,
  Flex,
  Select, Switch, Table, Tbody, Td,
  Text, Tr, useDisclosure,
} from '@chakra-ui/react';

// Components
import {
  GiveawaysActiveIcon,

} from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Card from 'components/Card/Card';
import Field from 'components/Fields';
import ErrorCard from 'components/Errors';
import SuccessCard from '../../../../components/Success';
import { Controller } from 'react-hook-form';
import Attention from '../../../../components/Modals/Attention';
import PriceInput from '../../PriceInput';

import { PLAN_TYPES } from '../../../../constants/plan';

const PartnerEditContent = ({ form, onSubmit, isSubmitting, errorCard, isNew, handleDelete }) => {

  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const history = useHistory();
  const handleCancelClick = useCallback(() => {
    history.push('/partners');
  }, [history]);

  const { control, register, handleSubmit, formState: { errors } } = form;

  return (
    <Box
      zIndex="9"
      position="relative"
    >
      {!isNew ? (
        <Breadcrumbs
          icon={GiveawaysActiveIcon}
          target="Partners"
          url="#/partners"
          current="Partner"
          variant="standart"
        />
      ) : (
        <Breadcrumbs
          icon={GiveawaysActiveIcon}
          target="Partners"
          url="#/partners"
          current="New Partner"
          variant="standart"
        />
      )}

      <form onSubmit={onSubmit}>

      <Flex
        gap="16px"
        position="absolute"
        mt="-92px"
        right="0"
        alignItems="center"
      >

        {isNew && (
          <Button
            variant="ghost-md"
            minW="120px"
            onClick={() => handleCancelClick()}
          >
            Cancel
          </Button>
        )}

        {!isNew && (
          <Button variant="ghost-md" w="120px" onClick={onOpenDelete}>
            Delete
          </Button>
        )}
        <Button
          isLoading={isSubmitting}
          variant="submit-md"
          w="120px"
          type='submit'
        >
          {!isNew ? 'Confirm' : 'Create'}
        </Button>

      </Flex>

      {errorCard && <ErrorCard error={errorCard} maxW="840px" />}
      {message && <SuccessCard message={message} maxW={'100%'} />}
      {error && <ErrorCard error={error} maxW={'100%'} />}

      <Box maxW="840px">

        <Text variant="title-lg" mt="40px" mb="14px">
          Partner info
        </Text>

        <Card padding="24px" mb="40px">

          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <Field
                id="name"
                label="Name"
                type="text"
                value={field.value}
                isValid={!errors.name}
                onChange={field.onChange}
                mb="24px"
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Field
                id="email"
                label="Email"
                type="text"
                value={field.value}
                isValid={!errors.email}
                onChange={field.onChange}
                mb="24px"
              />
            )}
          />
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <Field
                id="phone"
                label="Phone"
                type="text"
                value={field.value}
                isValid={!errors.phone}
                onChange={field.onChange}
                mb="24px"
              />
            )}
          />

          <Controller
            name="locationAddress"
            control={control}
            render={({ field }) => (
              <Field
                id="locationAddress"
                label="Location Address"
                type="text"
                value={field.value}
                isValid={!errors.locationAddress}
                onChange={field.onChange}
                mb="24px"
              />
            )}
          />

        </Card>
      </Box>
      </form>
      <Attention
        variant="remove"
        handle={handleDelete}
        isOpen={isOpenDelete}
        onOpen={onOpenDelete}
        onClose={onCloseDelete}
      />
    </Box>
  );
};

export default PartnerEditContent;
